import axios from 'axios'

const FILE_TYPE_MAP={
    UNKNOWN:0,  //未知
    DIR:999,    //文件夹
}
export function fetchFileTypeName(type) {
    for(let key in FILE_TYPE_MAP) {
        if( FILE_TYPE_MAP[key] == type) {
            return key;
        }
    }
    return '';
}
export function fetchFileTypeLabel(type) {
    try {
        if(typeof(type) != "undefined") {
            if(type == 999) {
                return '文件夹';
            }
            let typeName = fetchFileTypeName(type);
            if(typeName != '' && typeName != 'UNKNOWN') {
                return typeName.toLocaleLowerCase()+'文件';
            }
        }
    } catch (e) {
        console.error(e, new Date())
    }
    return '';
}
export function fetchFileTypeLabelByItem(item) {
    let fileTypeLabel = fetchFileTypeLabel(item.fileType)
    if (fileTypeLabel == '') {
        return (item.suffix != '' ? item.suffix : '') + '文件';
    }
    return fileTypeLabel;
}
export function fetchFileTypeIcon(type, iconType) {
    try {
        if(typeof(iconType) == "undefined" || iconType == null || iconType.length == 0) {
            iconType = 'others'; // others , big
        }
        if(typeof(type) != "undefined") {
            if(type == 1) {
                return 'icon-' + iconType+  '-pdf';
            } else if(type == 2 || type == 3) {
                return 'icon-' + iconType + '-ppt';
            } else if(type == 4 || type == 5) {
                return 'icon-' + iconType + '-word';
            } else if(type >= 6 && type <= 8) {
                return 'icon-' + iconType + '-excel';
            } else if(type == 9) {
                return 'icon-' + iconType + '-text';
            } else if(type >= 31 && type <= 60) {
                return 'icon-' + iconType + '-image';
            } else if(type >= 61 && type <= 90) {
                return 'icon-' + iconType + '-audio';
            } else if(type >= 91 && type <= 120) {
                return 'icon-' + iconType + '-video';
            } else if(type >= 121 && type <= 150) {
                return 'icon-' + iconType + '-zip';
            } else if(type == 999) {
                return 'icon-content-courses';
            }
        }
    } catch (e) {
        console.error(e, new Date())
    }
    return 'icon-others-other'; // 默认
}

// 创建一个axios实例
export function exportFile(url, options = {}) {
    return new Promise((resolve, reject) => {
        console.log(`${url} 请求数据，参数=>`, JSON.stringify(options))
        axios.defaults.headers["authorization"] = localStorage.getItem('rs_t')
        axios({
            method: 'post',
            url: url, // 请求地址
            data: options, // 参数
            responseType: 'blob' // 表明返回服务器返回的数据类型
        }).then(
            response => {
                resolve(response.data)
                console.log(response, new Date())

                const blob = new Blob([response.data])
                const fileName =options.attachName || '文件';
                const link = document.createElement('a')
                link.download = fileName
                link.style.display = 'none'
                link.href = URL.createObjectURL(blob)
                document.body.appendChild(link)
                link.click()
                URL.revokeObjectURL(link.href)
                document.body.removeChild(link)
            },
            err => {
                reject(err)
            }
        )
    })
}

export function fetchListRowIds(data) {
    let ids = []
    try{
        if(typeof(data) != "undefined" && data != null) {
           data.forEach(row => {
                ids.push(row.id)
            });
        }
    } catch (e) {
        console.error(e, new Date())
    }
    return ids;
}

export function resolveCategoryType(path, prefix) {
    try {
        if(typeof (prefix) == "undefined" || prefix == null || prefix == '') {
            prefix = '/main/resource-index/resource-content/'
        }
        if (typeof (path) == "undefined" || path == null || path.length < prefix.length){
            return 0;
        }
        let url = path.substring(prefix.length);
        const findEndIndex = url.indexOf('?');
        if(findEndIndex != -1) {
            url = url.substring(0, findEndIndex);
        }
        // console.log('path', path, ', type=', url, new Date());
        return parseInt(url)
    } catch (e) {
        console.error(e, new Date())
    }
    return 0;
}

export function fmtFileFullName(row) {
    try {
        if(typeof (row) == "undefined" || row == null) {
            return '';
        }
        return row.name + (row.isDir != 1 && row.suffix != '' ? '.'+row.suffix : '');
    } catch (e) {
        console.error(e)
    }
    return '';
}

export function fetchItemIndexById(fileData, id) {
    try {
        if (typeof (fileData) == "undefined" || fileData == null || fileData.length == 0) {
            return -1;
        }
        for (let i = 0; i < fileData.length; i++) {
            if (fileData[i].id == id) {
                return i;
            }
        }
    } catch (t) {
        console.error(t, new Date());
    }
    return -1;
}
export function fetchItemById(fileData, id) {
    try {
        if (typeof (fileData) == "undefined" || fileData == null || fileData.length == 0) {
            return null;
        }
        for (let i = 0; i < fileData.length; i++) {
            if (fileData[i].id == id) {
                return fileData[i];
            }
        }
    } catch (t) {
        console.error(t, new Date());
    }
    return null;
}